<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} phản ánh chờ duyệt
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="selection"
            width="40"
            v-if="mData.tableRules.allowSelect"
          ></el-table-column>
          <el-table-column label="STT" width="50">
            <template slot-scope="scope">
              <div class="text-center">
                {{ mData.tableRules.offset + scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="doi_tuong_phan_hoi" label="Đối tượng phản ánh">
          </el-table-column>
          <el-table-column prop="noi_dung" label="Nội dung"> </el-table-column>
          <el-table-column prop="thoi_diem_phan_hoi" label="Thời điểm phản ánh">
          </el-table-column>
          <!-- <el-table-column prop="hien_thi" label="Hiển thị">
            <template slot-scope="scope">
              <div class="text-center">
                {{scope.row.hien_thi ? 'Hiển thị' : 'Ẩn'}}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="trang_thai" label="Trạng thái">
            <template slot-scope="scope">
              <div class="text-center">
                {{
                  scope.row.trang_thai === 0
                    ? "Đã duyệt"
                    : scope.row.trang_thai === 1
                    ? "Đang chờ xử lý"
                    : "Từ chối"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="aLang.c_action"
            align="center"
            width="150px"
            v-if="mData.ifHavePermission"
          >
            <template slot-scope="scope">
              <!-- <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_accept"
              >
                <i class="fa fa-eye"></i>
              </el-button> -->
              <el-button
                size="mini"
                @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import PhanHoiModel from "./PhanHoiModel";
import mushroom from "../../../service/api/dulich-api";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "detail",
        moduleName: "PhanHoi",
        dataDefault: {},
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        ifHavePermission: false,
        dataForm: MethodService.copyObject(PhanHoiModel.dataForm),
        tableRules: MethodService.copyObject(PhanHoiModel.tableRules),
        validForm: PhanHoiModel.validForm,
      },
    };
  },
  methods: {
    async fn_initData() {
      this.mData.tableRules.filters = "trang_thai=1";
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-history",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
            },
          })
          .catch(() => {});
      }

      let res = await mushroom.phan_hoi.listAsync({
        filters: dataFilter.filters,
        limit: dataFilter.limit,
        offset: dataFilter.offset,
        sort: dataFilter.sort,
      });
      let resData = await this.fn_changeData(res.result);

      //end get name
      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initData();
      }
    },
    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      resData.forEach((row) => {
        row.thoi_diem_phan_hoi = MethodService.formatDate(
          row.thoi_diem_phan_hoi,
          "datetime"
        );
      });
      return resData;
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initData();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initData();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initData();
    },

    fn_handle(type, scope, row) {
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-accept",
          params: { id: row.id },
        });
      }
    },

    async fn_delete(id) {
      await mushroom.phan_hoi.deleteAsync(id);
      this.fn_initData();
    },
  },
  created: function () {
    if (this.mData.currentUser.roles.includes("Officer", "Admin")) {
      this.mData.ifHavePermission = true;
    }
    this.fn_initData();
  },
  mounted: function () {},
};
</script>
